import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconSpotifyStyle0 = gravityIconIndividualCss;

const GravityIconSpotify = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '1a65c9e71d47a147ec9ced9762ee9475ed1cfa0a', color: this.color, size: this.size }, h("svg", { key: '6219d339ea530f051b7b7eb188915acd2b977d24', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'f1ef5f9476f3cc5504c547574e3492cc316ada25', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16.324 9.979C13.423 8.256 8.637 8.097 5.868 8.938a.842.842 0 1 1-.489-1.611c3.18-.965 8.464-.779 11.804 1.204a.842.842 0 0 1-.86 1.448Zm-.095 2.552a.702.702 0 0 1-.965.23c-2.419-1.486-6.107-1.917-8.969-1.048a.703.703 0 0 1-.407-1.343c3.268-.992 7.332-.511 10.11 1.196a.7.7 0 0 1 .23.964Zm-1.101 2.45a.56.56 0 0 1-.772.187c-2.113-1.292-4.773-1.583-7.906-.868a.56.56 0 1 1-.25-1.093c3.428-.784 6.37-.447 8.741 1.003a.561.561 0 0 1 .187.771ZM11 2a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z", fill: "currentColor" }))));
    }
};
GravityIconSpotify.style = GravityIconSpotifyStyle0;

export { GravityIconSpotify as gravity_icon_spotify };

//# sourceMappingURL=gravity-icon-spotify.entry.js.map